import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Dashboard from "../Admin/Dashboard/Dashboard";
import CurrentDate from "../Admin/CurrentDate";
import ReactQuill from "react-quill";
import ImageWebp from "../../ImageWebp";
import Loader from "../Admin/Dashboard/Loader";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import baseApi from "../api";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactFileReader from "react-file-reader";
import "../../index.css";

const EditBlogCategory = (props) => {
  const [isLoading, setIsloading] = useState(false);
  const [SchemaData, setSchemaData] = useState({});
  const [preview, setPreview] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();
  // console.log("slug", slug);
  // console.log("preview", preview);

  useEffect(() => {
    axios.get(`${baseApi}website-schema/${id}`).then((res) => {
      setSchemaData(res.data.data);
      setIsloading(false);
      console.log("Res", res);
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      type: SchemaData.type,
      entityId: SchemaData.entityId,
      domain: SchemaData.domain,
      schema: JSON.stringify(SchemaData.schema, null, 2),
      page: SchemaData.page,
      isActive: true,
    },
    validationSchema: Yup.object({
      type: Yup.string().required("Please enter page type"),
      entityId: Yup.string().required("Please enter entityId"),
      domain: Yup.string().required("Please enter domain"),
      schema: Yup.string().required("Please enter schema"),
      page: Yup.string().required("Please enter page"),
    }),
    onSubmit: (values) => {
      setIsloading(true);
      const payload = {
        type: values.type,
        entityId: values.entityId,
        domain: values.domain,
        schema: JSON.parse(values.schema),
        page: values.page,
        domain: values.domain,
      };

      axios
        .put(`${baseApi}website-schema/${id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
          },
        })
        .then((res) => {
          setIsloading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  });

  return (
    <Fragment>
      <div className="admin_panel">
        <Dashboard />

        {!isLoading ? (
          <div className="container">
            <div className="col-sm-12">
              {" "}
              <CurrentDate />
              <form onSubmit={formik.handleSubmit} encType="application/json">
                <div className="form-group">
                  <label>
                    <h3>Type</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="type"
                    name="type"
                    {...formik.getFieldProps("type")}
                  />

                  <span className="text-danger">
                    {formik.touched.type && formik.errors.type ? (
                      <div>{formik.errors.type}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Entity Id</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entityId"
                    name="entityId"
                    {...formik.getFieldProps("entityId")}
                  />

                  <span className="text-danger">
                    {formik.touched.entityId && formik.errors.entityId ? (
                      <div>{formik.errors.entityId}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Domain</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="domain"
                    name="domain"
                    {...formik.getFieldProps("domain")}
                  />

                  <span className="text-danger">
                    {formik.touched.domain && formik.errors.domain ? (
                      <div>{formik.errors.domain}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Page/Slug</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="page"
                    name="page"
                    {...formik.getFieldProps("page")}
                  />

                  <span className="text-danger">
                    {formik.touched.page && formik.errors.page ? (
                      <div>{formik.errors.page}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Schema</h3>
                  </label>

                  <textarea
                    className="form-control"
                    name="schema"
                    rows="10"
                    value={formik.values.schema}
                    placeholder="Enter schema here..."
                    {...formik.getFieldProps("schema")}
                  />

                  <span className="text-danger">
                    {formik.touched.schema && formik.errors.schema ? (
                      <div>{formik.errors.schema}</div>
                    ) : null}
                  </span>
                </div>
                <hr />

                <div className="form-group">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Update Schema"
                  />
                  &nbsp;&nbsp;
                  <Link to="/blog-category">Back to website schema</Link>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </Fragment>
  );
};

export default EditBlogCategory;
